import { render } from "./Icon.vue?vue&type=template&id=1f3d304b&scoped=true&ts=true"
import script from "./Icon.ts?vue&type=script&lang=ts"
export * from "./Icon.ts?vue&type=script&lang=ts"

import "./Icon.scss?vue&type=style&index=0&id=1f3d304b&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3d304b"]])

export default __exports__